// apiClient.ts - 配置好的axios实例，用于统一处理认证头

import axios from "axios";
import jsCookie from "js-cookie";
import config from "../config";
import { logger } from "../utils/logger";
import { ElMessage } from "element-plus"; // 统一英文toast提示

// 创建axios实例
const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 10000,
});

// 请求拦截器 - 自动添加认证头
apiClient.interceptors.request.use(
  (config) => {
    const token = jsCookie.get("userToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 中文注释：2024-07-24 修复响应拦截器只返回 data 导致 response.data.code 报错的问题，现统一返回完整 response。
// 响应拦截器 - 统一处理后端返回格式和未授权错误
apiClient.interceptors.response.use(
  (response) => {
    // 统一处理后端返回格式 {code, message, data}
    // 直接返回完整 response，兼容所有 response.data.code 逻辑
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || "";
    const currentPath = window.location.pathname || "";

    if (status === 401) {
      const isLoginApi = requestUrl.includes("/auth/login");
      const alreadyOnLoginPage = currentPath === "/login";

      if (!isLoginApi && !alreadyOnLoginPage) {
        jsCookie.remove("userToken");
        jsCookie.remove("username");
        window.location.href = "/login";
      }
    } else {
      // 其他网络/服务器错误统一英文toast
      ElMessage.error("Network error, please try again later.");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
